import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from 'containers/Home';
import Gallery from 'containers/Gallery';
import GalleryImage from 'components/GalleryImage';

import { getBodyThemeColors } from "util/colors";

require('viewport-units-buggyfill').init();

class App extends Component {
    previousLocation = this.props.location;
    state = getBodyThemeColors();
    updateThemeColors = this.updateThemeColors.bind(this);

    componentWillUpdate(nextProps) {
        const { location } = this.props;

        if (
            nextProps.history.action !== "POP" &&
            (!location.state || !location.state.modal)
        ) {
            this.previousLocation = this.props.location;
        }
    }

    componentDidMount() {
        const hour = (new Date()).getHours()
        const night = hour < 6 || hour > 19;
        const theme = night ? "night" : "day";

        document.body.dataset.theme = theme;

        this.updateThemeColors();
    }

    updateThemeColors() {
        this.setState(getBodyThemeColors());
    }

    render() {
        const { location } = this.props;
        const isModal = !!(
            location.state &&
            location.state.modal &&
            this.previousLocation !== location
        );

        return (
            <React.Fragment>
                <Switch location={isModal ? this.previousLocation : location}>
                    <Route exact path='/gallery/:gallery' component={Gallery} />
                    <Route path='/gallery/:gallery/img/:src' component={GalleryImage} />
                    <Route exact path='/' render={() => (
                        <Home
                            topColor={this.state.topColor}
                            bottomColor={this.state.bottomColor}
                        />
                    )} />
                </Switch>
                {isModal ? <Route path='/gallery/:gallery/img/:src' component={GalleryImage} /> : null}
            </React.Fragment>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js